import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holiday-season',
  templateUrl: './holiday-season.component.html',
  styleUrls: ['./holiday-season.component.scss']
})
export class HolidaySeasonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/holiday-season/holiday-season.component.ts